import { render } from "./UserShowView.vue?vue&type=template&id=66a3955e&scoped=true"
import script from "./UserShowView.vue?vue&type=script&lang=js"
export * from "./UserShowView.vue?vue&type=script&lang=js"

import "./UserShowView.vue?vue&type=style&index=0&id=66a3955e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a3955e"]])

export default __exports__